<template>
    <b-button
        class="btn btn-dark mx-auto portfolio-list__btn"
        id="btn_show_more"
        @click="paginate"
        :disabled="list_loading"
        v-if="left_product !== 0"
    >
        <b-spinner small v-if="list_loading"></b-spinner>
        <span v-else>Show more</span>
    </b-button>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    name: "AlbumShowMoreBtn",
    props: ["left", "section"],
    computed: {
        ...mapGetters("album", ["list_loading", "left_product"])
    },
    methods: {
        ...mapActions("album", ["paginate"]),
        ...mapMutations("album", ["set_section", "set_left_product"])
    },
    beforeMount() {
        console.log(this.section)
        this.set_section(this.section);
        this.set_left_product(this.left <= 12 ? this.left : 12);
    }
};
</script>

<style scoped></style>
